import Axios from 'axios';
import ApiUtils from './api-utils';

export default {
  getReglementTiersDefaut: (param) => ApiUtils.responseParser(Axios.get(`/web/v1/tiers/${param.numTiers}/reglement-tiers?typeTiers=${param.typeTiers}&numEntite=${param.numEntite}&numArticle=${param.numArticle}&codeTArt=${param.codeTArt}`)),

  getPropositionReglementTiers: (numTiers, typeTiers, numEntite, numArticle, codeTArt, dateValidite, numLot) => {
    const params = ApiUtils.buildQueryParamsStr({ typeTiers, numEntite, numArticle, codeTArt, dateValidite, numLot });
    return ApiUtils.responseParser(Axios.get(`/web/v1/tiers/${numTiers}/reglement-commande${params}`));
  }
};
